import React, { Component } from 'react'
import { Modal, Button, TextInput } from '../'

class AddNewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      apartmentInput: '',
      emailInput: ''
    }
  }

  render() {
    const {
      show,
      header,
      apartment,
      emailOptional,
      add,
      cancel,
      explain,
      close,
      onCreate
    } = this.props
    const { apartmentInput, emailInput } = this.state
    const { containerStyle, smallTextStyle, buttonContainerStyle } = styles
    return (
      <Modal
        show={show}
        header={header}
        children={
          <div style={containerStyle}>
            <TextInput
              header={apartment}
              value={apartmentInput}
              onChange={value => this.setState({ apartmentInput: value })}
            />
            <TextInput
              header={emailOptional}
              value={emailInput}
              onChange={value => this.setState({ emailInput: value })}
            />
            <p style={smallTextStyle}>* {explain}</p>
            <div style={buttonContainerStyle}>
              <Button
                header={add}
                onClick={() => {
                  onCreate(apartmentInput, emailInput)
                  this.setState({ apartmentInput: '', emailInput: '' })
                }}
                marginRight={15}
                className={'filled'}
                color={'#3fa6c1'}
                hoverColor={'#77d8f4'}
              />
              <Button
                header={cancel}
                onClick={() => {
                  close()
                  this.setState({ apartmentInput: '', emailInput: '' })
                }}
                className={'filled'}
                color={'#e57373'}
                hoverColor={'#ffa4a2'}
              />
            </div>
          </div>
        }
      />
    )
  }
}

const styles = {
  containerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  buttonContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 50,
    marginTop: 50
  },
  smallTextStyle: {
    fontSize: 14,
    color: '#A9A9A9'
  }
}

export { AddNewModal }



// WEBPACK FOOTER //
// ./src/components/common/modals/AddNewModal.js